import { createContext, useContext, useLayoutEffect } from "react";

// Presentation only: the matched route's existing provider supplies branding.
// An owner token prevents an older provider cleanup from clearing a newer one.
export const LoaderBrandingContext = createContext(null);
// Read-only presentation context; publishing still uses the owner-scoped hook.
export const ActiveLoaderBrandingContext = createContext(null);

export function useLoaderBranding({ scope, name = "", logoUrl = "", merchantCode = "" }) {
  const publish = useContext(LoaderBrandingContext);
  useLayoutEffect(() => publish?.({ scope, name, logoUrl, merchantCode }),
    [publish, scope, name, logoUrl, merchantCode]);
}
